<mat-dialog-content>
  <img
    *ngIf="imageFileUrl$ | async as imageFileUrl; else loading"
    class="image-responsive"
    loading="lazy"
    [src]="imageFileUrl">
</mat-dialog-content>

<ng-template #loading>
  <div class="image-loading-container">
    <ngx-spinner
      [fullScreen]="false"
      name="loadingImage"
      type="square-loader"
      size="medium"
      class="loading-spinner">
    </ngx-spinner>
  </div>
</ng-template>
